import { createSelector } from 'reselect'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { SummaryAPIResponse } from '@/features/financial-insights/shared/utils'
import { ReduxState } from '@/utils/typeHelpers'

interface InsightsState {
  summary: {
    [summaryId: string]: SummaryAPIResponse[]
  }
}

const initialState: InsightsState = {
  summary: {},
}

const insightsSlice = createSlice({
  name: 'insights',
  initialState,
  reducers: {
    addInsightSummary: (
      state,
      action: PayloadAction<{ key: string; response: SummaryAPIResponse[] }>
    ) => {
      state.summary[action.payload.key] = action.payload.response
    },
  },
})

export const { addInsightSummary } = insightsSlice.actions

export default insightsSlice.reducer

const selectInsightSummaries = (state: ReduxState) => state.insights.summary

export const selectInsightSummary = createSelector(
  selectInsightSummaries,
  (_: unknown, key: string) => key, // via FETCH_INSIGHTS_SUMMARY_KEY
  (summaries, key) => (summaries[key] ? summaries[key] : [])
)
